import cn from "@/utils/class-names";
import { BiChevronDown } from "react-icons/bi";
import { Accordion } from "rizzui";
import LogsActionTable from "../table/logs-action-table";
import { IEnquiryEntry } from "@/utilities/types/EnquiryEntry";
import { LogActionTableRef } from "../table/logs-action-table";

interface ActivityHistoryProps {
  lead: IEnquiryEntry;
  tableLogActionRef?: React.RefObject<LogActionTableRef>;
}

export default function ActivityHistory({ lead, tableLogActionRef }: ActivityHistoryProps) {
  return (
    <div
      className={cn(
        "border border-gray-200 h-full rounded-lg p-4 col-span-full mt-4"
      )}
    >
      <Accordion>
        <Accordion.Header>
          {({ open }) => (
            <div
              className={cn(
                "flex w-full cursor-pointer items-center justify-between text-xl font-semibold",
                open && "mb-4"
              )}
            >
              Activity history
              <BiChevronDown
                className={cn(
                  "h-5 w-5 -rotate-90 transform transition-transform duration-300",
                  open && "-rotate-0"
                )}
              />
            </div>
          )}
        </Accordion.Header>
        <Accordion.Body className="mb-7">
          <LogsActionTable
            tableDataPushParams={false}
            submissionId={lead?.id}
            ref={tableLogActionRef}
          />
        </Accordion.Body>
      </Accordion>
    </div>
  );
}
